import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import Loader from 'components/loader/Loader';
import FileInput from 'components/input-field/FileInput';
import SaveButton from 'components/buttons/SaveButton';
import { PatientSchema } from './Validation';
import { AddPatientRes, AddPatientTodo } from 'redux/slice/admin/patient/AddPatient';

class AddPatientForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                name: '',
                phone: '',
                age: '',
                gender: '',
                email: '',
                status: ''
            }
        };
    }
    status_option = [
        { "value": 'Active', "label": "Active" },
        { "value": 'Inactive', "label": "Inactive" }
    ]

    gender_option = [
        { "value": 'male', "label": "Male" },
        { "value": 'female', "label": "Female" }
    ]

    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        dispatch(AddPatientTodo(values)).then(() => this.add_res());

    }

    add_res = () => {
        if (AddPatientRes?.success) {
            toast.success(AddPatientRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                this.props.history.push('/admin/patient-list');
            }, 1200);
            this.setState({ spiner: false });
        } else {
            toast.error(AddPatientRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }

    render() {
        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={PatientSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Patient Name'
                                                placeholder=''
                                                name='name'
                                                value={values.name || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.name && touched.name ? (<span className='text-danger form_label' >{errors.name}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Contact Number'
                                                placeholder=''
                                                name='phone'
                                                value={values.phone || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.phone && touched.phone ? (<span className='text-danger form_label' >{errors.phone}</span>) : null}
                                            />
                                        </Col>

                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Email'
                                                placeholder=''
                                                name='email'
                                                value={values.email || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email && touched.email ? (<span className='text-danger form_label' >{errors.email}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Age'
                                                placeholder=''
                                                name='age'
                                                value={values.age || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.age && touched.age ? (<span className='text-danger form_label' >{errors.age}</span>) : null}
                                            />
                                        </Col>


                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Gender'
                                                disabled={false}
                                                options={this.gender_option}
                                                name='gender'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('gender', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.gender && touched.gender ? (<span className='text-danger form_label' >{errors.gender}</span>) : null} />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={this.status_option}
                                                name='status'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>

                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'SAVE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer />
            </>
        )
    }
}
export default connect()(withRouter(AddPatientForm));